import { GDSSpaceToken, Prefixed } from '../stitches.config';

type SpacingTokenMap = {
  [K in GDSSpaceToken]: Prefixed<'$', K>;
};

export const spacingTokenMap: SpacingTokenMap = {
  none: '$none',
  eighth: '$eighth',
  quarter: '$quarter',
  half: '$half',
  threeQuarters: '$threeQuarters',
  one: '$one',
  oneAndHalf: '$oneAndHalf',
  two: '$two',
  twoAndHalf: '$twoAndHalf',
  three: '$three',
  four: '$four',
  five: '$five',
};
